// extracted by mini-css-extract-plugin
module.exports = {"book-contact":"G_cD","bookContact":"G_cD","book-contact-icon":"G_cF","bookContactIcon":"G_cF","book-contact-link":"G_cG","bookContactLink":"G_cG"};